import React, { useEffect, useState, useCallback } from "react";
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from '../../components/Pagination/Pagination';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import { FaCircle, FaArrowUp, FaArrowDown, FaExternalLinkAlt, FaMapMarkerAlt } from 'react-icons/fa';
import { API } from 'aws-amplify';
import Moment from 'react-moment';
import moment from 'moment';
import { Link } from 'react-router-dom';
import "./AssetsConnections.scss";
import Map from '../../components/Map/Map';

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const pin_green = "https://maps.google.com/mapfiles/ms/icons/green-dot.png";
const pin_yellow = "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";

const AssetConnections = (props) => {
    const [assets, setAssets] = useState([]);
    const [assetList, setAssetList] = useState([]);
    const [assetConnections, setAssetConnections] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [asset, setAsset] = useState('');
    const [locationList, setLocationList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [location, setLocation] = useState('');
    const [country, setCountry] = useState('');
    const [showExtraCols, setShowExtraCols] = useState(false);
    const [statusFilter, setStatusFilter] = useState('all');
    const [orderBy, setOrderBy] = useState('name'); // 'name', 'uptime_1d', 'uptime_3d', 'uptime_7d', 'status'
    const [orderDirection, setOrderDirection] = useState('asc'); // 'asc' or 'desc'

    let formatDate = ['DD-MM-YYYY', 'dd/MM/yyyy']
    if (props.formatDate !== formatDate[0]) {
        formatDate = ['MM-DD-YYYY', 'MM/dd/yyyy']
    }


    const DAY_MS = 24 * 60 * 60 * 1000;
    const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

    const toggleRow = (index) => {
        setExpandedRows((prevExpandedRows) =>
            prevExpandedRows.includes(index)
                ? prevExpandedRows.filter((i) => i !== index)
                : [...prevExpandedRows, index]
        );
    };

    // Load asset
    /* eslint-disable no-alert, no-console */
    useEffect(() => {
        const fetchAssets = async () => {
            setIsLoading(true);

            // const sites = await API.get('sites','/', params)

            let data = await API.get('list_asset', '/', params)

            data = data.sort((a, b) => (a.name > b.name) ? 1 : -1)
            // data = data.map(item => {
            //     let stat = 'text-success';
            //     switch (item.status) {
            //         case 'active':
            //             stat = 'text-success';
            //             break;
            //         case 'inactive':
            //             stat = 'text-secondary';
            //             break;
            //         case 'removed':
            //             stat = 'text-danger';
            //             break;
            //         default:
            //             stat = 'text-success';
            //     }

            //     //  const site = sites.find(i => i.id === item.site_id)

            //     return {
            //         ...item,
            //         statusCss: stat,
            //         //  site: (site && site.name) || '',
            //     }
            // })

            //Get user asset list
            let user_assets = []
            // user_assets = await API.get('user_assets','/' + props.user.username, params)
            user_assets = props.user.user_assets

            let assetsFiltered = []
            if (user_assets) {
                // user_assets = user_assets.assets;
                assetsFiltered = data.filter(x => user_assets.find(i => i === x.id));
            }

            if (assetsFiltered.length > 0) {
                setAssets(assetsFiltered);
                setAssetList(assetsFiltered);
            }

            setIsLoading(false);
        }

        if (Object.keys(props.user).length !== 0)
            fetchAssets();

    }, [props.user]);

    useEffect(() => {
        const fetchAssets = async () => {
            let data = await API.get('assets_connections', '/', params)
            setAssetConnections(data);
        }
        if (assets.length > 0 && assetConnections.length === 0)
            fetchAssets();
    }, [assets]);

    useEffect(() => {
        if (assets.length > 0 && assetConnections.length > 0) {
            const parsed_data = assets.map(asset => {
                const relatedConnections = assetConnections.filter(
                    conn => conn.asset_id === asset.id
                );
                
                if (!relatedConnections[0]) {
                    return {
                        ...asset,
                        connection_status: false,
                        connection_history: [],
                        connected_time_1d: 0,
                        connected_time_3d: 0,
                        connected_time_7d: 0,
                        statusCss: 'text-secondary',
                    };
                }

                const { status, history } = relatedConnections[0];
                const connectedPercent1d = calculateConnectedTime(status, history, DAY_MS);
                const connectedPercent3d = calculateConnectedTime(status, history, 3 * DAY_MS);
                const connectedPercent7d = calculateConnectedTime(status, history, WEEK_MS);

                return {
                    ...asset,
                    connection_status: relatedConnections[0]?.status,
                    connection_history: relatedConnections[0]?.history || [],
                    connected_time_1d: connectedPercent1d,
                    connected_time_3d: connectedPercent3d,
                    connected_time_7d: connectedPercent7d,
                    statusCss: relatedConnections[0]?.status ?  'text-success' : 'text-secondary',
                };
            })
            setAssets(parsed_data);
        }
    }, [assetConnections]);

    const calculateConnectedTime = (status, history, durationMs) => {
        const now = new Date();
        const boundaryTime = new Date(now.getTime() - durationMs);

        // History is assumed oldest to newest, status matches the last entry
        const connectionEvents = [...history]
            .map(dateStr => new Date(dateStr))
            .filter(date => !isNaN(date.getTime()))
            .sort((a, b) => a - b); // oldest to newest

        let totalConnectedMs = 0;
        let lastTime = now;
        let currentStatus = status; // Start with current status

        // Process events from newest to oldest
        for (let i = connectionEvents.length - 1; i >= 0; i--) {
            const eventTime = connectionEvents[i];
            if (eventTime > now) continue; // skip future events

            // If the event is before the boundary, only count overlap
            if (eventTime < boundaryTime) {
                if (currentStatus) {
                    totalConnectedMs += lastTime - boundaryTime;
                }
                break;
            }

            if (currentStatus) {
                totalConnectedMs += lastTime - eventTime;
            }
            // Alternate status
            currentStatus = !currentStatus;
            lastTime = eventTime;
        }

        // If the window starts before the first event, handle the initial interval
        if (connectionEvents.length === 0 || connectionEvents[0] > boundaryTime) {
            if (currentStatus) {
                totalConnectedMs += lastTime - boundaryTime;
            }
        }

        // Clamp to window size
        if (totalConnectedMs > durationMs) totalConnectedMs = durationMs;
        if (totalConnectedMs < 0) totalConnectedMs = 0;

        return Math.round((totalConnectedMs / durationMs) * 100);
    }

    // Load country
    useEffect(() => {
        const fetchCountry = async () => {
            let loc = [...new Set(assets.map(item => item.country))];
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)

            if (loc.length === 1)
                setCountry(loc[0]);

            setCountryList(loc);
        }
        fetchCountry();

    }, [assets]);

    // Load location
    useEffect(() => {
        const fetchLocation = async () => {
            let loc = []
            if (country) {
                loc = [...new Set(assets.filter(item => item.country === country).map(item => item.location))];
            } else {
                loc = [...new Set(assets.map(item => item.location))];
            }
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)
            setLocationList(loc);
        }
        fetchLocation();
    }, [assets, country]);

    useEffect(() => {
        const handleSearch = () => {
            let results = assets;
            // Site Reference
            if (asset) {
                results = results.filter(results =>
                    (results.id && results.id.toLowerCase().includes(asset.toLowerCase())) ||
                    (results.name && results.name.toLowerCase().includes(asset.toLowerCase())) ||
                    (results.address && results.address.toLowerCase().includes(asset.toLowerCase())))
            }
            // country
            if (country) {
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
                )
            }
            // Location
            if (location) {
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
                )
            }
            console.log(results)
            // Status filter
            if (statusFilter === 'connected') {
                console.log(results.filter(results => results.connection_status === true))
                console.log(results.filter(results => results.connection_status !== true))
                results = results.filter(results => results.connection_status === true);
            } else if (statusFilter === 'disconnected') {
                console.log(results.filter(results => results.connection_status === false))
                results = results.filter(results => results.connection_status === false);
            }
            // Order selector
            const sortFn = (a, b, key) => {
                if (orderDirection === 'asc') {
                    return a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0;
                } else {
                    return a[key] < b[key] ? 1 : a[key] > b[key] ? -1 : 0;
                }
            };
            if (orderBy === 'name') {
                results = results.slice().sort((a, b) => {
                    const nameA = a.name || '';
                    const nameB = b.name || '';
                    // Place empty names at the end regardless of direction
                    if (!nameA && !nameB) return 0;
                    if (!nameA) return 1;
                    if (!nameB) return -1;
                    return orderDirection === 'asc'
                        ? nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' })
                        : nameB.localeCompare(nameA, undefined, { numeric: true, sensitivity: 'base' });
                });
            } else if (orderBy === 'uptime_1d') {
                results = results.slice().sort((a, b) => orderDirection === 'asc' ? a.connected_time_1d - b.connected_time_1d : b.connected_time_1d - a.connected_time_1d);
            } else if (orderBy === 'uptime_3d') {
                results = results.slice().sort((a, b) => orderDirection === 'asc' ? a.connected_time_3d - b.connected_time_3d : b.connected_time_3d - a.connected_time_3d);
            } else if (orderBy === 'uptime_7d') {
                results = results.slice().sort((a, b) => orderDirection === 'asc' ? a.connected_time_7d - b.connected_time_7d : b.connected_time_7d - a.connected_time_7d);
            } else if (orderBy === 'status') {
                results = results.slice().sort((a, b) => orderDirection === 'asc' ? (a.connection_status === true) - (b.connection_status === true) : (b.connection_status === true) - (a.connection_status === true));
            }
            setAssetList(results);
            paginate(1, true);
        }
        handleSearch();
        setExpandedRows([]);
    }, [country, location, asset, assets, statusFilter, orderBy, orderDirection]);

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItemList = assetList.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber, reset = false) => {
        setCurrentPage(pageNumber);
        if (!reset) setExpandedRows([]);
    };

    // Helper to get last N status changes
    const getLastStatusChanges = (history, status, n = 5) => {
        // history: array of timestamps (oldest to newest), status: current status
        let events = [];
        let currentStatus = status;
        for (let i = history.length - 1; i >= 0 && events.length < n; i--) {
            events.push({
                timestamp: history[i],
                status: currentStatus
            });
            currentStatus = !currentStatus;
        }
        return events;
    };

    // Helper to get uptime/downtime stats for the last week
    const getUptimeStats = (status, history, now, weekMs) => {
        // Calculate total downtime, number of disconnects, and longest downtime in the last week
        const boundaryTime = new Date(now.getTime() - weekMs);
        const events = [...history]
            .map(dateStr => new Date(dateStr))
            .filter(date => !isNaN(date.getTime()) && date <= now)
            .sort((a, b) => a - b); // oldest to newest
        let lastTime = now;
        let currentStatus = status;
        let totalDowntime = 0;
        let disconnectEvents = 0;
        let longestDowntime = 0;
        let currentDowntime = 0;
        for (let i = events.length - 1; i >= 0; i--) {
            const eventTime = events[i];
            if (eventTime < boundaryTime) {
                if (!currentStatus) {
                    const dt = lastTime - boundaryTime;
                    totalDowntime += dt;
                    currentDowntime += dt;
                    if (currentDowntime > longestDowntime) longestDowntime = currentDowntime;
                }
                break;
            }
            if (!currentStatus) {
                const dt = lastTime - eventTime;
                totalDowntime += dt;
                currentDowntime += dt;
                if (currentDowntime > longestDowntime) longestDowntime = currentDowntime;
                disconnectEvents++;
            } else {
                if (currentDowntime > longestDowntime) longestDowntime = currentDowntime;
                currentDowntime = 0;
            }
            currentStatus = !currentStatus;
            lastTime = eventTime;
        }
        // If the window starts before the first event
        if (events.length === 0 || events[0] > boundaryTime) {
            if (!currentStatus) {
                const dt = lastTime - boundaryTime;
                totalDowntime += dt;
                currentDowntime += dt;
                if (currentDowntime > longestDowntime) longestDowntime = currentDowntime;
            }
        }
        return {
            totalDowntime,
            disconnectEvents,
            longestDowntime
        };
    };

    // Helper to get trend indicator (compare 1d uptime to previous 1d uptime)
    const getTrendIndicator = (status, history) => {
        const DAY_MS = 24 * 60 * 60 * 1000;
        const now = new Date();
        const today = calculateConnectedTime(status, history, DAY_MS);
        // For previous day, shift window by 1 day
        const prevDayBoundary = new Date(now.getTime() - DAY_MS * 2);
        const prevDayEnd = new Date(now.getTime() - DAY_MS);
        // Filter history to only include events before prevDayEnd
        const prevHistory = history.filter(ts => new Date(ts) < prevDayEnd);
        // Get status at prevDayEnd
        let currentStatus = status;
        let lastTime = new Date(history.length > 0 ? history[history.length - 1] : now);
        for (let i = history.length - 1; i >= 0; i--) {
            const eventTime = new Date(history[i]);
            if (eventTime < prevDayEnd) break;
            currentStatus = !currentStatus;
            lastTime = eventTime;
        }
        const prevDay = calculateConnectedTime(currentStatus, prevHistory, DAY_MS);
        if (today > prevDay) return 'up';
        if (today < prevDay) return 'down';
        return 'same';
    };

    const handleToggleCols = () => setShowExtraCols(v => !v);

    // Helper to create marker links for assets
    const getAssetMarkers = (assets) => {
        return assets
            .filter(a => a.latitude && a.longitude)
            .map(a => {
                let last_upd = 'Not Available';
                if (a.last_update) {
                    last_upd = '<span class="text-dark">' +
                        moment(a.last_update).format((formatDate[0] || 'DD-MM-YYYY') + ' HH:mm:ss') + '</span>';
                }
                return {
                    id: a.id,
                    coords: { lat: parseFloat(a.latitude), lng: parseFloat(a.longitude) },
                    icon: a.connection_status ? pin_green : pin_yellow,
                    title: a.name,
                    content: `<div class="map-div">` +
                        `<span class="map-dev">` +
                            `<a href="/device_info/${a.id}" class="text-primary" id="marker-link-${a.id}">${a.name || ''}</a>` +
                        `</span><br/><br/>` +
                        `<span class="text-dark"><strong>${a.location || ''}</strong></span><br/>` +
                        `<span class="text-dark">${a.address || ''}</span><br/><br/>` +
                        `<span class="text-dark">Last update: ${last_upd}</span><br/><br/>` +
                        `<span class="text-secondary small">Location: ${a.latitude}, ${a.longitude}</span><br/>` +
                    `</div>`
                };
            });
    };

    const markerRefs = React.useRef({});

    async function addMarkers(map, links) {
        const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        let infoWindow;
        const markers = [];
        links.forEach((link) => {
            const icon = document.createElement("img");
            icon.src = link.icon;
            const marker = new AdvancedMarkerElement({
                map,
                position: link.coords,
                title: link.title,
                content: icon,
            });
            marker.addListener("click", () => {
                if (infoWindow) infoWindow.close();
                infoWindow = new window.google.maps.InfoWindow({ content: link.content });
                infoWindow.open(map, marker);
            });
            markers.push({ id: link.id, marker });
        });
        // Store marker references by id for external activation
        markerRefs.current = {};
        markers.forEach(({ id, marker }) => {
            markerRefs.current[id] = marker;
        });
    }

    const activateMapMarker = (id) => {
        const marker = markerRefs.current[id];
        if (marker) {
            window.google.maps.event.trigger(marker, 'click');
        }
    };

    // Load Map
    // Add initial coordinates and zoom to the map, it will re-center and resize when it finishes loading assets
    const mapProps = {
        options: { center: { lat: parseFloat(process.env.REACT_APP_MAP_LAT), lng: parseFloat(process.env.REACT_APP_MAP_LNG) }, zoom: 12, scrollwheel: true, mapId: "de70c7e1386f9fba" },

        onMount: addMarkers,
        onMountProps: getAssetMarkers(assetList),
        className: 'gmaps',
    }

    // Reload the map only when necessary
    const MemoMap = useCallback(<Map {...mapProps} />, [mapProps])

    return (
        <div className="DeviceList">
            <div className="col-md-12">
                <div className="row header pb-0">
                    <div>Sensors</div>
                    <div className="col-6">
                        <div className="row">
                            <Form.Group controlId="site_ref" className="col-md-6 ps-4">
                                <Form.Control
                                    as="input"
                                    value={asset}
                                    onChange={e => { setAsset(e.target.value) }}
                                    type="text" />
                            </Form.Group>
                            <Form.Group controlId="country" className="col-md-3">
                                <Form.Control
                                    as="select"
                                    value={country}
                                    onChange={e => { setCountry(e.target.value) }}>
                                    <option value="">Country</option>
                                    {countryList.map((item, i) =>
                                        <option key={`country` + i} value={item}>{item}</option>
                                    )}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="location" className="col-md-3">
                                <Form.Control
                                    as="select"
                                    value={location}
                                    onChange={e => { setLocation(e.target.value) }}>
                                    <option value="">Location</option>
                                    {locationList.map((item, i) =>
                                        <option key={`loc` + i} value={item}>{item}</option>
                                    )}
                                </Form.Control>
                            </Form.Group>
                        </div>
                    </div>
                    <div className="col-5 d-flex align-items-baseline justify-content-end ">
                        {/* Status Filter */}
                        <Form.Group controlId="statusFilter" className="mr-2">
                            <Form.Control as="select" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                                <option value="all">All</option>
                                <option value="connected">Connected</option>
                                <option value="disconnected">Disconnected</option>
                            </Form.Control>
                        </Form.Group>
                        {/* Order Selector */}
                        <Form.Group controlId="orderBy" className="mr-2">
                            <Form.Control as="select" value={orderBy} onChange={e => setOrderBy(e.target.value)}>
                                <option value="name">Order by Name</option>
                                <option value="uptime_1d">Order by 1d Uptime</option>
                                <option value="uptime_3d">Order by 3d Uptime</option>
                                <option value="uptime_7d">Order by 7d Uptime</option>
                                <option value="status">Order by Status</option>
                            </Form.Control>
                        </Form.Group>
                        {/* Order Direction Button */}
                        <Button variant="outline-secondary" className="mr-2" onClick={() => setOrderDirection(orderDirection === 'asc' ? 'desc' : 'asc')} title="Toggle order direction">
                            {orderDirection === 'asc' ? <FaArrowUp /> : <FaArrowDown />}
                        </Button>
                        {/* Toggle Columns Button */}
                        <Button variant="secondary" className="mr-1" onClick={handleToggleCols}>
                            {showExtraCols ? 'Show Map' : 'Hide Map'}
                        </Button>
                    </div>
                </div>
            </div>
            {/* Map + Table Layout */}
            <div className="row" style={{ width: '100%' }}>
                {!showExtraCols && (
                    <div className="col-md-4">
                        {MemoMap}
                    </div>
                )}
                <div className={showExtraCols ? "col-md-12" : "col-md-8"}>
                    <div className="row">
                        <div className="col-md-12 div-content">
                            {(!isLoading) ? (
                                (currentItemList.length === 0) ? (
                                    ''
                                ) : (
                                    <div>
                                        <Table responsive bordered hover variant="light">
                                            <thead>
                                                <tr>
                                                    <th className="border-bottom">Sensor</th>
                                                    <th className="border-bottom">ID</th>
                                                    {/* <th className="border-bottom">Site</th> */}
                                                    {showExtraCols && <th className="border-bottom">Country</th>}
                                                    {showExtraCols && <th className="border-bottom">Location</th>}
                                                    {showExtraCols && <th className="border-bottom">Make</th>}
                                                    <th className="border-bottom">1d (%)</th>
                                                    <th className="border-bottom">3d (%)</th>
                                                    <th className="border-bottom">7d (%)</th>
                                                    <th className="border-bottom">Status</th>
                                                    <th className="border-bottom">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItemList.map((item, i) => (
                                                    <>
                                                    <tr
                                                        key={item.id}
                                                        className="expandable-row"
                                                        onClick={() => toggleRow(i)}
                                                    >
                                                        <td className="border-bottom" key={item.name}>
                                                            {item.name}
                                                        </td>
                                                        <td className="border-bottom" key={item.id}>
                                                            {item.id}
                                                        </td>
                                                        {/* <td className="border-bottom">{ item.site }</td> */}
                                                        {showExtraCols && <td className="border-bottom">{item.country}</td>}
                                                        {showExtraCols && <td className="border-bottom">{item.location}</td>}
                                                        {showExtraCols && <td className="border-bottom">{item.make}</td>}
                                                        <td className="border-bottom">{item.connected_time_1d}%</td>
                                                        <td className="border-bottom">{item.connected_time_3d}%</td>
                                                        <td className="border-bottom">{item.connected_time_7d}%</td>
                                                        <td className={"border-bottom text-nowrap small " + item.statusCss}><FaCircle /> {item.connection_status ? 'Connected' : 'Disconnected'}</td>
                                                        <td className="border-bottom text-nowrap">
                                                            <Link to={`/device_info/${item.id}`} className="btn btn-outline-primary btn-sm mr-1" target="_blank" rel="noopener noreferrer">
                                                                Info <FaExternalLinkAlt style={{marginLeft: 4}} />
                                                            </Link>
                                                            <Button variant="outline-success" size="sm" onClick={e => { e.stopPropagation(); activateMapMarker(item.id); }} title="Show on Map">
                                                                <FaMapMarkerAlt />
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                    {expandedRows.includes(i) && (
                                                        <tr>
                                                            <td colSpan="10" className="bg-light border-bottom">
                                                                <div className="row">
                                                                    {/* Additional Info (toggle) */}
                                                                    <div className={showExtraCols ? "col-md-4" : "col-md-4"}>
                                                                        <strong>Additional Info:</strong>
                                                                        <ul className="mb-0">
                                                                            <li><strong>ID: </strong>{item.id}</li>
                                                                            <li><strong>Site: </strong>{item.site}</li>
                                                                            <li><strong>Last Update: </strong>
                                                                                {item.last_update ?
                                                                                    (<Moment local format={formatDate[0] + " HH:mm:ss"} date={item.last_update} className={moment(item.last_update).isSameOrAfter(new Date(), "day") ? "text-dark" : "text-danger"} />)
                                                                                    : ""}
                                                                            </li>
                                                                            <li><strong>Activated: </strong>{item.status}</li>
                                                                        </ul>
                                                                    </div>
                                                                    {/* Uptime/Downtime Statistics + Uptime Trend */}
                                                                    <div className="col-md-4">
                                                                        <strong>Uptime/Downtime Statistics (last 7d):</strong>
                                                                        {(() => {
                                                                            const stats = getUptimeStats(item.connection_status, item.connection_history, new Date(), 7 * 24 * 60 * 60 * 1000);
                                                                            const fmt = ms => {
                                                                                const h = Math.floor(ms / 3600000);
                                                                                const m = Math.floor((ms % 3600000) / 60000);
                                                                                return `${h}h ${m}m`;
                                                                            };
                                                                            return (
                                                                                <ul className="mb-0">
                                                                                    <li>Total Downtime: {fmt(stats.totalDowntime)}</li>
                                                                                    <li>Disconnect Events: {stats.disconnectEvents}</li>
                                                                                    <li>Longest Continuous Downtime: {fmt(stats.longestDowntime)}</li>
                                                                                </ul>
                                                                            );
                                                                        })()}
                                                                        <div className="mt-2">
                                                                            <strong>Uptime Trend (1d vs prev 1d): </strong>
                                                                            {(() => {
                                                                                const trend = getTrendIndicator(item.connection_status, item.connection_history);
                                                                                if (trend === 'up') return <span style={{color: 'green'}}>▲ Improving</span>;
                                                                                if (trend === 'down') return <span style={{color: 'red'}}>▼ Worsening</span>;
                                                                                return <span style={{color: 'gray'}}>▬ No Change</span>;
                                                                            })()}
                                                                        </div>
                                                                    </div>
                                                                    {/* Connection History (last 10 events) */}
                                                                    <div className="col-md-4">
                                                                        <strong>Connection History:</strong>
                                                                        <Table size="sm" bordered className="w-auto mt-1 mb-2">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Timestamp</th>
                                                                                    <th>Status</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {getLastStatusChanges(item.connection_history, item.connection_status, 10).map((ev, idx) => (
                                                                                    <tr key={idx}>
                                                                                        <td><Moment local format={formatDate[0] + " HH:mm:ss"} date={ev.timestamp} /></td>
                                                                                        <td>{ev.status ? 'Connected' : 'Disconnected'}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </Table>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    </>
                                                ))}
                                            </tbody>
                                        </Table>
                                        <Pagination
                                            sizePerPage={itemsPerPage}
                                            currentPage={currentPage}
                                            totalSize={assetList.length}
                                            changeCurrentPage={paginate}
                                            theme="bootstrap"
                                        />
                                    </div>
                                )) : (
                                <div className="col-md-12">
                                    <Spinner animation="grow" size="sm" role="status" variant="warning" />
                                    <span className="text-dark">  Loading...</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
        viewPermissions: state.auth.viewPermissions,
    };
};

export default connect(mapStateToProps)(AssetConnections);
